import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  startIntegration,
  stopIntegration,
  clearIntegration
} from "../../../integration";
import {
  dismissIntegration,
  launchIntegration,
  getCaseState
} from "./CaseSlice";
import { getPageConfig } from "../PageConfigSlice";

function useIntegration(defaultIntegrationConfig) {
  const pageConfig = useSelector(getPageConfig);
  const dispatch = useDispatch();
  const caseState = useSelector(getCaseState);

  const triggerIntegration = useCallback(
    (config) => {
      if (caseState.isIntegrationLaunched) return;

      dispatch(launchIntegration());
      const features = config.base.features || {};
      const forceSessionApi = pageConfig.sessionApiHost ?
        {baseUrl: pageConfig.sessionApiHost}
        : {};
      const integrationConfig = {
        ...config,
        base: {
          ...config.base,
          features: {
            ...features,
            forceSessionApi
          },
          highlight: config.base.highlight ?? pageConfig.isHighlightActive
        },
        shouldMountIntegrationByDefault:
          pageConfig.shouldMountIntegrationByDefault
      };

      startIntegration(integrationConfig);
    },
    [
      pageConfig.isDefaultIntegration,
      pageConfig.shouldMountIntegrationByDefault,
      pageConfig.sessionApiHost,
      pageConfig.isHighlightActive,
      caseState.isIntegrationLaunched,
      dispatch
    ]
  );

  useEffect(() => {
    if (pageConfig.isDefaultIntegration && defaultIntegrationConfig) {
      triggerIntegration(defaultIntegrationConfig);
    }

    return () => {
      dispatch(dismissIntegration());
      stopIntegration();
      clearIntegration();
    };
  }, [pageConfig.isDefaultIntegration, defaultIntegrationConfig]);

  return { triggerIntegration };
}

export { useIntegration };
